import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  CardHeader,
  Button,
  CustomInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import PersonalAddDescriptionModal from "../Modals/Agents/PersonalAddDescriptionModal";
import {
  errorHandler,
  getFileExtension,
  getImageDimensionClass,
  isProPlusUser,
  showToast,
  uploadFileOnServer,
} from "../../../../helper-methods";
import { agentCredentialsConfig } from "../../../../config";
import { useSelector } from "react-redux";
import { RegexConfig } from "../../../../config/RegexConfig";
import {
  createAgentWebsiteDetail,
  getAgentProfileDetail,
  getAgentWebsiteDetail,
  updateAgentWebsiteDetail,
} from "../../../../http/http-calls";
import Swal from "sweetalert2";
import WhiteLabelUIColor from "../../components/Modals/Company/WhiteLabelUIColor";

// import KYCAlertCard from "../kyc-alert";
import PersonalWebsiteWarningModal from "./PersonalWebsiteWarningModal";
import ImageCropModal from "./ImageCropModal";

const initialFormFields = {
  name: "",
  phone: "",
  email: "",
  nnaLink: "",
  linkedinLink: "",
  facebookLink: "",
  instagramLink: "",
  credentials: {
    backgroundCheckReport: false,
    eoInsurance: false,
    idVerification: false,
    lssCertification: false,
    mdTitleProducerLicense: false,
    nnaCertification: false,
    notaryBond: false,
    notaryLicense: false,
    nyTotalCloser: false,
    ronCredentials: false,
    titleProducerLicense: false,
    w9Credentials: false,
    barLicense: false,
  },
  showClientsWorkedWith: false,
  showTotalJobsCompleted: false,
  totalJobsCompleted: 0,
  totalClientsWorkedWith: 0,
  profileLogo: {},
  profilePicture: {},
  favIcon: {},
  currentUI: "demoUI1",
};

const initialIsDirty = {
  name: false,
  phone: false,
  email: false,
  nnaLink: false,
  linkedinLink: false,
  facebookLink: false,
  instagramLink: false,
};

const colorsUI = {
  demoUI1: {
    primary: "#4c96ce", // default color
    secondary: "#16346c",
    tertiary: "#0f2550",
  },
  demoUI2: {
    primary: "#4d648d",
    secondary: "#0f1c2e",
    tertiary: "#172c48",
  },
  demoUI3: {
    primary: "#c53628",
    secondary: "#062536",
    tertiary: "#093953",
  },
  demoUI4: {
    primary: "#ffc700",
    secondary: "#115080",
    tertiary: "#0d3e63",
  },
};
const PersonalWebsiteSetp1 = ({ manageLoadingState }, ref) => {
  const history = useHistory();
  const ImageLogoRef = useRef();
  const ImageProfilePicRef = useRef();
  const ImageFavIconRef = useRef();

  const userData = useSelector((state) => state?.userData);

  const [agentWebsiteDetails, setAgentWebsiteDetails] = useState({});
  const [formFields, setFormFields] = useState(initialFormFields);
  const [isDirty, setIsDirty] = useState(initialIsDirty);
  const [errors, setErrors] = useState({});
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFilesLinks, setUploadedFilesLinks] = useState([]);
  const [serviceDetails, setServiceDetails] = useState([]);
  const [isDefaultUiSelected, setIsDefaultUiSelected] = useState(true);
  const [imageLogoClass, setImageLogoClass] = useState("");
  const [customizedUI, setCustomizedUI] = useState({
    isChosen: false,
    data: null,
  });

  const [websiteWarningModal, setWebsiteWarningModal] = useState({
    isOpen: false,
    data: null,
  });

  const [imageCropModal, setImageCropModal] = useState({
    isOpen: false,
    data: null,
    fieldName: "",
    fileType: "",
    fileName: "",
  });

  const _togglewebsiteWarningModal = (isOpen = false, data = null) => {
    setWebsiteWarningModal({ isOpen, data });
  };

  const _toggleImageCropModal = (
    isOpen = false,
    data = null,
    fieldName = "",
    fileType = "",
    fileName = ""
  ) => {
    setImageCropModal({ isOpen, data, fieldName, fileType, fileName });
  };

  const [seed, setSeed] = useState(0);

  const [addServiceModal, setAddServiceModal] = useState({
    isOpen: false,
    data: null,
  });

  const [whiteLabelUIColorModal, setWhiteLabelUIColorModal] = useState({
    isOpen: false,
  });

  // const [loading, setloading] = useState({
  //   isFormSubmitting: false,
  // });

  // const _manageLoadingState = (key = "", value = false) => {
  //   setloading((prev) => ({
  //     ...prev,
  //     [key]: value,
  //   }));
  // };

  const _toggleAddServiceModal = (isOpen = false, data = null) => {
    setAddServiceModal({ isOpen, data });
  };

  const _setFormData = (agentWebsite) => {
    const newFormFields = { ...formFields };

    newFormFields["name"] = agentWebsite?.name || "";
    newFormFields["email"] = agentWebsite?.email || "";
    newFormFields["phone"] = agentWebsite?.phone || "";
    newFormFields["nnaLink"] = agentWebsite?.nnaLink || "";
    newFormFields["facebookLink"] = agentWebsite?.facebookLink || "";
    newFormFields["linkedinLink"] = agentWebsite?.linkedinLink || "";
    newFormFields["instagramLink"] = agentWebsite?.instagramLink || "";
    newFormFields["facebookLink"] = agentWebsite?.facebookLink || "";
    newFormFields["credentials"] = agentWebsite?.chooseCredentials || {};
    newFormFields["showClientsWorkedWith"] =
      agentWebsite?.showClientsWorkedWith || false;
    newFormFields["showTotalJobsCompleted"] =
      agentWebsite?.showTotalJobsCompleted || false;
    newFormFields["totalJobsCompleted"] =
      agentWebsite?.totalJobsCompleted || "";
    newFormFields["totalClientsWorkedWith"] =
      agentWebsite?.totalClientsWorkedWith || "";

    newFormFields["profileLogo"]["uploadedUrl"] = agentWebsite?.logo || "";
    newFormFields["profilePicture"]["uploadedUrl"] =
      agentWebsite?.profilePicture || "";
    newFormFields["favIcon"]["uploadedUrl"] = agentWebsite?.favIcon || "";

    const services = agentWebsite?.serviceDetails?.map((each) => ({
      id: Date.now() + Math.random(),
      topic: each?.topic,
      description: each?.description,
    }));

    setServiceDetails(services || []);

    if (agentWebsite?.colorSetting !== "customizedUiSetting") {
      newFormFields["currentUI"] = agentWebsite?.colorSetting || "demoUI1";
    } else {
      newFormFields["currentUI"] = null;
      setCustomizedUI({
        isChosen: true,
        data: agentWebsite?.customizedUiSetting,
      });
    }

    setFormFields(newFormFields);

    setUploadedFilesLinks(agentWebsite?.photoGallery);
    setSeed(Math.random());
  };

  const _getAgentWebsiteDetails = async () => {
    try {
      const res = await getAgentWebsiteDetail();

      if (res?.agentWebsite) {
        setAgentWebsiteDetails(res?.agentWebsite);
        _setFormData(res?.agentWebsite);
      }
    } catch (err) {
      errorHandler(err);
    }
  };

  const _checkForKYCAndStandardFee = async () => {
    try {
      const res = await getAgentProfileDetail();

      if (
        (res?.agent?.kyc &&
          !res?.agent?.kyc?.paymentEnabled &&
          !res?.agent?.kyc?.payoutEnabled) ||
        !res?.agent?.isAtleastOneStandardFeesAndWitnessFeeAvailable
      ) {
        _togglewebsiteWarningModal(true, res?.agent);
        return;
      }
    } catch (err) {
      errorHandler(err);
      history.push("/agent/profile");
    }
  };

  useEffect(() => {
    if (!isProPlusUser()) {
      history.goBack();
      return;
    }

    _checkForKYCAndStandardFee();

    _getAgentWebsiteDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _onFormFieldsChange = (key, value) => {
    const newFormFields = { ...formFields };

    if (key === "credentials") {
      let temp = newFormFields[key][value];

      if (temp) {
        // delete newFormFields[key][value];
        newFormFields[key][value] = false;
      } else {
        newFormFields[key][value] = true;
      }
    } else if (
      key === "totalJobsCompleted" ||
      key === "totalClientsWorkedWith"
    ) {
      if (isNaN(value) || +value < 0 || value.includes(".")) return;
      newFormFields[key] = value;
    } else {
      newFormFields[key] = value;
    }

    if (key === "currentUI") {
      // if (value === "demoUI1") {
      //   setIsDefaultUiSelected(true);
      // } else {
      //   setIsDefaultUiSelected(false);
      // }
      setIsDefaultUiSelected(true);

      setCustomizedUI({
        isChosen: false,
        data: null,
      });
      setSeed(Math.random());
    }

    setFormFields(newFormFields);
    setIsFormDirty(true);
  };

  const _onBlurFormFields = (key) => {
    const newFormFields = { ...formFields };
    const newIsDirty = { ...isDirty };

    newIsDirty[key] = true;

    setIsDirty(newIsDirty);
    _validateFormfields({ newFormFields, newIsDirty });

    setIsFormDirty(true);
  };

  const _validateFormfields = ({ newFormFields, newIsDirty }) => {
    return new Promise((resolve) => {
      let isFormValid = true;
      const newErrors = {};

      Object.keys(newFormFields)?.forEach((key) => {
        if (newIsDirty[key]) {
          switch (key) {
            case "name": {
              if (newIsDirty[key]) {
                if (newFormFields[key]?.trim()?.length) {
                  if (
                    newFormFields[key].length >= 2 &&
                    newFormFields[key].length <= 50
                  ) {
                    newErrors[key] = null;
                    newIsDirty[key] = false;
                  } else {
                    newErrors[key] =
                      "*Minimum 2 characters and Maximum 50 characters allowed ";
                    isFormValid = false;
                  }
                } else {
                  newErrors[key] = "*Required";
                  isFormValid = false;
                }
              }
              break;
            }

            case "phone": {
              if (newIsDirty[key]) {
                if (String(newFormFields[key])?.trim()?.length) {
                  if (RegexConfig?.phone?.test(newFormFields[key])) {
                    newErrors[key] = null;
                    newIsDirty[key] = false;
                  } else {
                    newErrors[key] = "*Invalid phone";
                    isFormValid = false;
                  }
                } else {
                  newErrors[key] = "*Required";
                  isFormValid = false;
                }
              }
              break;
            }

            case "email": {
              if (newIsDirty[key]) {
                if (newFormFields[key]?.trim()?.length) {
                  if (RegexConfig?.email?.test(newFormFields[key])) {
                    newErrors[key] = null;
                    newIsDirty[key] = false;
                  } else {
                    newErrors[key] = "*Invalid email";
                    isFormValid = false;
                  }
                } else {
                  newErrors[key] = "*Required";
                  isFormValid = false;
                }
              }
              break;
            }

            case "nnaLink": {
              // case "instagramLink": // case "linkedinLink": // case "facebookLink":
              if (newIsDirty[key]) {
                if (newFormFields[key]?.trim()?.length) {
                  if (RegexConfig?.url?.test(newFormFields[key])) {
                    newErrors[key] = null;
                    newIsDirty[key] = false;
                  } else {
                    newErrors[key] = "*Invalid link";
                    isFormValid = false;
                  }
                } else {
                  newErrors[key] = "*Required";
                  isFormValid = false;
                }
              }
              break;
            }

            case "instagramLink":
            case "linkedinLink":
            case "facebookLink": {
              if (newIsDirty[key]) {
                if (newFormFields[key]?.trim()?.length) {
                  if (RegexConfig?.url?.test(newFormFields[key])) {
                    newErrors[key] = null;
                    newIsDirty[key] = false;
                  } else {
                    newErrors[key] = "*Invalid link";
                    isFormValid = false;
                  }
                } else {
                  newErrors[key] = null;
                  newIsDirty[key] = false;
                }
              }
              break;
            }

            case "totalJobsCompleted": {
              if (newIsDirty[key]) {
                if (newFormFields["showTotalJobsCompleted"]) {
                  if (newFormFields[key]) {
                    newErrors[key] = null;
                    newIsDirty[key] = false;
                  } else {
                    newErrors[key] = "*Required";
                    isFormValid = false;
                  }
                }
              }
              break;
            }

            case "totalClientsWorkedWith": {
              if (newIsDirty[key]) {
                if (newFormFields["showClientsWorkedWith"]) {
                  if (newFormFields[key]) {
                    newErrors[key] = null;
                    newIsDirty[key] = false;
                  } else {
                    newErrors[key] = "*Required";
                    isFormValid = false;
                  }
                }
              }
              break;
            }

            default:
          }
        }
      });

      console.log({ newErrors });
      setIsDirty((prev) => ({
        ...prev,
        ...newIsDirty,
      }));
      setErrors((prev) => ({
        ...prev,
        ...newErrors,
      }));
      resolve(isFormValid);
    });
  };

  const _markAllFieldDirty = () => {
    return new Promise((resolve, reject) => {
      const newIsDirty = { ...isDirty };
      Object.keys(newIsDirty).forEach((e) => {
        newIsDirty[e] = true;
      });

      setIsDirty(newIsDirty);

      resolve(newIsDirty);
      //   this.setState({ formFields }, () => resolve(true));
    });
  };

  const _updateFileImageBasicDetail = (fieldName, event) => {
    const newFormFields = { ...formFields };
    setIsFormDirty(true);

    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length
    ) {
      let objFile = event.target.files[0];
      let objFileType = objFile.type.split("/")[0];

      if (objFileType === "image") {
        if (objFile?.size / 1000 > 500) {
          errorHandler({
            reason: "Max allowed file size: 500kb",
          });
          return;
        }

        if (fieldName !== "profileLogo") {
          _toggleImageCropModal(
            true,
            URL.createObjectURL(objFile),
            fieldName,
            objFileType,
            objFile?.name
          );
        } else {
          newFormFields[fieldName].file = {
            previewBlob: URL.createObjectURL(objFile),
            uploadData: objFile,
            type: objFileType === "application" ? "pdf" : objFileType,
          };
          if (newFormFields?.[fieldName]?.uploadedUrl) {
            delete newFormFields?.[fieldName]?.["uploadedUrl"];
          }

          setFormFields(newFormFields);
        }
      } else {
        showToast("Only Image file is allowed", "error");
      }
    }
  };

  const _setCroppedImg = (objFile, fieldName, fileType) => {
    const newFormFields = { ...formFields };

    newFormFields[fieldName].file = {
      previewBlob: URL.createObjectURL(objFile),
      uploadData: objFile,
      type: fileType === "application" ? "pdf" : fileType,
    };
    if (newFormFields?.[fieldName]?.uploadedUrl) {
      delete newFormFields?.[fieldName]?.["uploadedUrl"];
    }

    setFormFields(newFormFields);
  };

  const _createPayload = async () => {
    const payload = {
      name: formFields?.name || "",
      phone: formFields?.phone || "",
      email: formFields?.email || "",
      linkedinLink: formFields?.linkedinLink || "",
      nnaLink: formFields?.nnaLink || "",
      facebookLink: formFields?.facebookLink || "",
      instagramLink: formFields?.instagramLink || "",
      showClientsWorkedWith: formFields?.showClientsWorkedWith || false,
      showTotalJobsCompleted: formFields?.showTotalJobsCompleted || false,
      // totalJobsCompleted: Number(formFields?.totalJobsCompleted) || 0,
      // totalClientsWorkedWith: Number(formFields?.totalClientsWorkedWith) || 0,
      chooseCredentials: formFields?.credentials || {},
    };

    if (formFields?.showClientsWorkedWith) {
      payload["totalClientsWorkedWith"] =
        Number(formFields?.totalClientsWorkedWith) || 0;
    }
    if (formFields?.showTotalJobsCompleted) {
      payload["totalJobsCompleted"] =
        Number(formFields?.totalJobsCompleted) || 0;
    }

    if (serviceDetails?.length) {
      const serviceDetailsArr = serviceDetails?.map((each) => ({
        topic: each?.topic,
        description: each?.description,
      }));

      payload["serviceDetails"] = serviceDetailsArr;
    }

    payload["photoGallery"] = uploadedFilesLinks || [];
    if (selectedFiles && selectedFiles?.length) {
      const uploadedFilesRes = await uploadFileOnServer(selectedFiles);

      const files = uploadedFilesRes?.map((each) => each?.url);

      payload["photoGallery"] = [...payload["photoGallery"], ...files];
    }

    if (formFields?.profileLogo?.file) {
      const uploadedFilesRes = await uploadFileOnServer([
        formFields?.profileLogo?.file,
      ]);
      payload["logo"] = uploadedFilesRes[0].url;
    }

    if (formFields?.profilePicture?.file) {
      const uploadedFilesRes = await uploadFileOnServer([
        formFields?.profilePicture?.file,
      ]);
      payload["profilePicture"] = uploadedFilesRes[0].url;
    }

    if (formFields?.favIcon?.file) {
      const uploadedFilesRes = await uploadFileOnServer([
        formFields?.favIcon?.file,
      ]);
      payload["favIcon"] = uploadedFilesRes[0].url;
    }

    if (customizedUI?.isChosen) {
      payload["customizedUiSetting"] = customizedUI?.data;
      payload["colorSetting"] = "customizedUiSetting";
    } else {
      if (formFields?.currentUI) {
        payload["colorSetting"] = formFields?.currentUI;
        payload["defaultUiSetting"] = colorsUI[formFields?.currentUI];

        // if (isDefaultUiSelected) {
        //   payload["defaultUiSetting"] = colorsUI[formFields?.currentUI];
        // } else {
        //   payload["customizedUiSetting"] = colorsUI[formFields?.currentUI];
        // }
      }
    }
    payload["isDefaultUiSelected"] = isDefaultUiSelected;

    return payload;
  };

  const _toggleWhiteLabelUIColor = (isOpen = false) => {
    setWhiteLabelUIColorModal({ isOpen });
  };

  const _onSaveCustomizedUIColor = (data) => {
    setCustomizedUI({
      isChosen: true,
      data: data,
    });
    const newFormFields = { ...formFields };

    newFormFields["currentUI"] = null;
    setFormFields(newFormFields);
    setIsFormDirty(true);
    setIsDefaultUiSelected(false);
  };

  const _onSubmit = async () => {
    console.log("step 1 submit func called");

    if (isFormDirty || !Object?.keys(agentWebsiteDetails)?.length) {
      try {
        manageLoadingState("stepLoading", true);
        const newFormFields = { ...formFields };
        const newIsDirty = await _markAllFieldDirty();

        const isValidate = await _validateFormfields({
          newFormFields,
          newIsDirty,
        });

        // return false;
        if (!isValidate) {
          errorHandler("Please fill all mandatory form fields correctly!");
          manageLoadingState("stepLoading", false);
          return false;
        } else {
          const payload = await _createPayload();

          const res = await getAgentWebsiteDetail();

          if (Object?.keys(res?.agentWebsite)?.length) {
            await updateAgentWebsiteDetail(payload);
          } else {
            await createAgentWebsiteDetail(payload);
          }
          showToast("Successfully created", "success");
          manageLoadingState("stepLoading", false);
          setIsFormDirty(false);
          return true;
        }
      } catch (err) {
        errorHandler(err);
        manageLoadingState("stepLoading", false);
        return false;
      }
    } else {
      return true;
    }
  };

  const _onFileMultiSelect = (fieldName, e) => {
    let fileList = Array.from(e.target.files);
    let files = [...selectedFiles];

    setIsFormDirty(true);

    let allowedAmount = selectedFiles?.length + fileList?.length;
    if (allowedAmount > 10) {
      errorHandler({ reason: "Max 10 photos are allowed" });
      return;
    }

    for (let i = 0; i < fileList.length; i++) {
      if (
        fileList[i]?.type?.split("/")[1] !== "png" &&
        fileList[i]?.type?.split("/")[1] !== "jpg" &&
        fileList[i]?.type?.split("/")[1] !== "jpeg"
      ) {
        errorHandler({
          reason:
            "Only file with the following extensions are allowed: png, jpg, jpeg",
        });
        continue;
      }

      if (fileList[i]?.size / 1000 > 500) {
        errorHandler({
          reason: "Max allowed file size: 500kb",
        });
        continue;
      }
      files.unshift({
        previewBlob: URL.createObjectURL(fileList[i]),
        uploadData: fileList[i],
        type:
          fileList[i]?.type?.split("/")[0] === "application"
            ? "pdf"
            : fileList[i]?.type?.split("/")[0] || "",
      });
    }

    setSelectedFiles(files);
  };

  const _renderFileOnType = (type, item) => {
    switch (type) {
      case "pdf":
        return (
          <i
            className="fa fa-file-pdf-o docIcon"
            // onClick={() => this._onToggleDocumentViewModal(item, true)}
          />
        );

      case "docx":
      case "doc":
        return (
          <i
            className="fa fa-file-text-o docIcon"
            // onClick={() => this._onToggleDocumentViewModal(item, true)}
          />
        );

      case "jpg":
      case "png":
        return (
          <img
            src={item.previewBlob ? item.previewBlob : item}
            alt="Img"
            // onClick={() => this._onToggleDocumentViewModal(item, true)}
          />
        );
      default:
    }
  };

  const _deleteImage = (arrayName, previewUrl) => {
    if (arrayName === "selectedFiles") {
      let newArray;

      if (previewUrl.previewBlob) {
        newArray = selectedFiles.filter(
          (item) => item.previewBlob !== previewUrl.previewBlob
        );
      } else {
        newArray = selectedFiles.filter((item) => item !== previewUrl);
      }

      setSelectedFiles(newArray);
    }
  };

  const _deleteUploadedGalleryImage = (arrayName, previewUrl) => {
    if (arrayName === "uploadedFilesLinks") {
      let newArray;

      if (previewUrl) {
        newArray = uploadedFilesLinks?.filter((item) => item !== previewUrl);
      }

      setUploadedFilesLinks(newArray);
    }
  };

  const _removeService = (id) => {
    const newServiceDetails = [...serviceDetails];

    const serviceIndex = newServiceDetails?.findIndex(
      (each) => each?.id === id
    );
    // console.log({ serviceIndex });

    if (serviceIndex > -1) {
      newServiceDetails.splice(serviceIndex, 1);
      // console.log({ newServiceDetails });
    }
    setServiceDetails(newServiceDetails);

    setIsFormDirty(true);
  };

  const _removeServiceAlert = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to remove this service.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        _removeService(id);
      }
    });
  };

  const _isNumber = (e) => {
    var charCode = e.which ? e.which : e.keyCode;

    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return e.preventDefault();
    return;
  };

  useImperativeHandle(ref, () => ({
    _onSubmit,
    isWebsiteLaunched: agentWebsiteDetails?.isWebsiteLaunched,
    // isFormComplete,
  }));

  return (
    <>
      <Card className="mt-3">
        <CardBody>
          <Row>
            <Col lg={4} md={6} sm={6} className="text-center mt-3 mb-4">
              {/* you have to add class according to there length  the class is rectangle and square*/}
              <Label className="d-block mb-2">Upload Logo</Label>
              <Label
                // className={`profileCompanyLogo rectangle`}
                className={`profileCompanyLogo ${
                  imageLogoClass || "rectangle"
                }`}
              >
                <Input
                  type="file"
                  style={{ display: "none" }}
                  accept="image/x-png,image/gif,image/jpeg"
                  value=""
                  // disabled={loading}
                  onChange={(event) =>
                    _updateFileImageBasicDetail("profileLogo", event)
                  }
                  placeholder=" "
                />
                <img
                  ref={ImageLogoRef}
                  src={
                    formFields?.profileLogo?.uploadedUrl ||
                    (formFields?.profileLogo?.file &&
                    formFields?.profileLogo?.file?.previewBlob
                      ? formFields?.profileLogo?.file?.previewBlob
                      : require("../../../../assets/img/placeholder-img.png")
                          .default)
                  }
                  alt="Profile Img"
                  onLoad={() =>
                    setImageLogoClass(getImageDimensionClass(ImageLogoRef))
                  }
                />
                <i className="fa fa-pencil"></i>
              </Label>
            </Col>
            <Col lg={4} md={6} sm={6} className="text-center mt-3 mb-4">
              {/* you have to add class according to there length  the class is rectangle and square*/}
              <Label className="d-block mb-2">Profile Pic</Label>
              <Label
                // className={`profileCompanyLogo rectangle`}
                className={`profileCompanyLogo ${
                  imageLogoClass || "rectangle"
                }`}
              >
                <Input
                  type="file"
                  style={{ display: "none" }}
                  accept="image/x-png,image/gif,image/jpeg"
                  //  disabled={loading}
                  value=""
                  onChange={(event) =>
                    _updateFileImageBasicDetail("profilePicture", event)
                  }
                  placeholder=" "
                />
                <img
                  ref={ImageProfilePicRef}
                  src={
                    formFields?.profilePicture?.uploadedUrl ||
                    (formFields?.profilePicture?.file &&
                    formFields?.profilePicture?.file?.previewBlob
                      ? formFields?.profilePicture?.file?.previewBlob
                      : require("../../../../assets/img/placeholder-img.png")
                          .default)
                  }
                  alt="Profile Img"
                  onLoad={() =>
                    setImageLogoClass(
                      getImageDimensionClass(ImageProfilePicRef)
                    )
                  }
                />
                <i className="fa fa-pencil"></i>
              </Label>
            </Col>
            <Col lg={4} md={12} className="text-center mt-3 mb-4">
              {/* you have to add class according to there length  the class is rectangle and square*/}
              <Label className="d-block mb-2">Favicon</Label>
              <Label
                // className={`profileCompanyLogo rectangle`}
                className={`profileCompanyLogo ${
                  imageLogoClass || "rectangle"
                }`}
              >
                <Input
                  type="file"
                  style={{ display: "none" }}
                  accept="image/x-png,image/gif,image/jpeg"
                  //  disabled={loading}
                  value=""
                  onChange={(event) =>
                    _updateFileImageBasicDetail("favIcon", event)
                  }
                  placeholder=" "
                />
                <img
                  ref={ImageFavIconRef}
                  src={
                    formFields?.favIcon?.uploadedUrl ||
                    (formFields?.favIcon?.file &&
                    formFields?.favIcon?.file?.previewBlob
                      ? formFields?.favIcon?.file?.previewBlob
                      : require("../../../../assets/img/placeholder-img.png")
                          .default)
                  }
                  alt="Fav Icon"
                  onLoad={() =>
                    setImageLogoClass(getImageDimensionClass(ImageFavIconRef))
                  }
                />
                <i className="fa fa-pencil"></i>
              </Label>
            </Col>
            <Col lg={4} md={6} sm={6}>
              <FormGroup className="floatingLabel">
                <Input
                  placeholder=" "
                  value={formFields?.name}
                  onChange={(e) => _onFormFieldsChange("name", e.target.value)}
                  onBlur={() => _onBlurFormFields("name")}
                />
                <Label>Enter Your Name</Label>
                {errors?.name ? (
                  <p className="validation-error">{errors?.name}</p>
                ) : null}
              </FormGroup>
            </Col>
            <Col lg={4} md={6} sm={6}>
              <FormGroup className="floatingLabel">
                <Input
                  placeholder=" "
                  value={formFields?.phone}
                  onChange={(e) => _onFormFieldsChange("phone", e.target.value)}
                  onBlur={() => _onBlurFormFields("phone")}
                  onKeyPress={(e) => _isNumber(e)}
                />
                <Label>Contact Phone No.</Label>
                {errors?.phone ? (
                  <p className="validation-error">{errors?.phone}</p>
                ) : null}
              </FormGroup>
            </Col>
            <Col lg={4} md={6} sm={6}>
              <FormGroup className="floatingLabel">
                <Input
                  placeholder=" "
                  value={formFields?.email}
                  onChange={(e) => _onFormFieldsChange("email", e.target.value)}
                  onBlur={() => _onBlurFormFields("email")}
                />
                <Label>Contact Email</Label>
                {errors?.email ? (
                  <p className="validation-error">{errors?.email}</p>
                ) : null}
              </FormGroup>
            </Col>
            <Col lg={4} md={6} sm={6}>
              <FormGroup className="floatingLabel">
                <Input
                  placeholder=" "
                  value={formFields?.nnaLink}
                  onChange={(e) =>
                    _onFormFieldsChange("nnaLink", e.target.value)
                  }
                  onBlur={() => _onBlurFormFields("nnaLink")}
                />
                <Label>NNA Link</Label>
                {errors?.nnaLink ? (
                  <p className="validation-error">{errors?.nnaLink}</p>
                ) : null}
              </FormGroup>
            </Col>
            <Col lg={4} md={6} sm={6}>
              <FormGroup className="floatingLabel">
                <Input
                  placeholder=" "
                  value={formFields?.linkedinLink}
                  onChange={(e) =>
                    _onFormFieldsChange("linkedinLink", e.target.value)
                  }
                  onBlur={() => _onBlurFormFields("linkedinLink")}
                />
                <Label>Linkedin Link</Label>
                {errors?.linkedinLink ? (
                  <p className="validation-error">{errors?.linkedinLink}</p>
                ) : null}
              </FormGroup>
            </Col>
            <Col lg={4} md={6} sm={6}>
              <FormGroup className="floatingLabel">
                <Input
                  placeholder=" "
                  value={formFields?.facebookLink}
                  onChange={(e) =>
                    _onFormFieldsChange("facebookLink", e.target.value)
                  }
                  onBlur={() => _onBlurFormFields("facebookLink")}
                />
                <Label>Facebook Link</Label>
                {errors?.facebookLink ? (
                  <p className="validation-error">{errors?.facebookLink}</p>
                ) : null}
              </FormGroup>
            </Col>
            <Col lg={4} md={6} sm={6}>
              <FormGroup className="floatingLabel">
                <Input
                  placeholder=" "
                  value={formFields?.instagramLink}
                  onChange={(e) =>
                    _onFormFieldsChange("instagramLink", e.target.value)
                  }
                  onBlur={() => _onBlurFormFields("instagramLink")}
                />
                <Label>Instagram Link</Label>
                {errors?.instagramLink ? (
                  <p className="validation-error">{errors?.instagramLink}</p>
                ) : null}
              </FormGroup>
            </Col>
          </Row>

          <Card className="serviceList">
            <CardHeader>
              Add Your Service Details
              <Button
                color="link"
                onClick={() => _toggleAddServiceModal(true, null)}
              >
                New
              </Button>
            </CardHeader>
            <CardBody>
              <ul className="">
                {serviceDetails?.length ? (
                  serviceDetails?.map((each) => (
                    <li key={each?.id}>
                      <div className="listHeader">
                        <h1>{each?.topic}</h1>
                        <div>
                          <Button
                            color="link"
                            onClick={() => _toggleAddServiceModal(true, each)}
                          >
                            <img
                              src={
                                require("../../../../assets/img/pencil.svg")
                                  .default
                              }
                              alt="edit"
                            />
                          </Button>
                          <Button
                            color="link"
                            onClick={() => _removeServiceAlert(each?.id)}
                          >
                            <img
                              src={
                                require("../../../../assets/img/deleteIcon.svg")
                                  .default
                              }
                              alt="delete"
                            />
                          </Button>
                        </div>
                      </div>
                      <p>{each?.description}</p>
                    </li>
                  ))
                ) : (
                  <li>
                     <div className="nodata mb-0">
                        <img
                          src={
                            require("../../../../assets/img/noData.svg").default
                          }
                          alt="no data"
                        />
                        <p>There is no data to display</p>
                      </div>
                  </li>
                )}
              </ul>
            </CardBody>
          </Card>

          <h4 className="fs-14 fw-500">Photo gallery</h4>
          <div className="attachementWrap">
            <div className="uploadItem">
              <Label>
                <Input
                  type="file"
                  multiple
                  value=""
                  accept="image/png, image/jpeg"
                  onChange={(e) => _onFileMultiSelect("selectedFiles", e)}
                  // onChange={(e) => _updateFile("attatchments", e)}
                />
                <img
                  src={require("../../../../assets/img/addItem.svg").default}
                  alt="file"
                />
              </Label>
            </div>

            <div className="d-flex flex-wrap gap-5">
              {selectedFiles?.length > 0 &&
                selectedFiles?.map((item) => {
                  return (
                    <div className="uploadItem mb-2">
                      {!item?.previewBlob &&
                        _renderFileOnType(getFileExtension(item), item)}
                      {item?.previewBlob &&
                        _renderFileOnType(
                          getFileExtension(item?.uploadData?.name),
                          item
                        )}{" "}
                      <div
                        className="removeIcon"
                        onClick={() => _deleteImage("selectedFiles", item)}
                      >
                        <img
                          src={
                            require("../../../../assets/img/close.png").default
                          }
                          alt="close"
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div className="attachementWrap">
            <div className="d-flex flex-wrap gap-5">
              {uploadedFilesLinks?.length > 0 &&
                uploadedFilesLinks?.map((item) => {
                  return (
                    <div className="uploadItem mb-2">
                      <img
                        src={item}
                        alt="Img"
                        // onClick={() => this._onToggleDocumentViewModal(item, true)}
                      />
                      <div
                        className="removeIcon"
                        onClick={() =>
                          _deleteUploadedGalleryImage(
                            "uploadedFilesLinks",
                            item
                          )
                        }
                      >
                        <img
                          src={
                            require("../../../../assets/img/close.png").default
                          }
                          alt="close"
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <Row className="mb-4">
            <Col className="mt-4" xl={4} lg={6}>
              <CustomInput
                className="mb-2"
                type="checkbox"
                id="exampleCustomCheckboxClients"
                label="Show how many clients I have worked with"
                checked={formFields?.showClientsWorkedWith}
                onChange={(e) =>
                  _onFormFieldsChange("showClientsWorkedWith", e.target.checked)
                }
              />

              {formFields?.showClientsWorkedWith === true ? (
                <>
                  <InputGroup>
                    <Input
                      placeholder="Enter"
                      value={formFields?.totalClientsWorkedWith}
                      onChange={(e) =>
                        _onFormFieldsChange(
                          "totalClientsWorkedWith",
                          e.target.value
                        )
                      }
                      onBlur={() => _onBlurFormFields("totalClientsWorkedWith")}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText style={{ fontSize: 14 }}>
                        Client
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                  {errors?.totalClientsWorkedWith ? (
                    <p className="validation-error">
                      {errors?.totalClientsWorkedWith}
                    </p>
                  ) : null}
                </>
              ) : null}
            </Col>
            <Col className="mt-4" xl={4} lg={6}>
              <CustomInput
                className="mb-2"
                type="checkbox"
                id="exampleCustomCheckboxJobs"
                label="Show how many Jobs I have completed"
                checked={formFields?.showTotalJobsCompleted}
                onChange={(e) =>
                  _onFormFieldsChange(
                    "showTotalJobsCompleted",
                    e.target.checked
                  )
                }
              />
              {formFields?.showTotalJobsCompleted === true ? (
                <>
                  <InputGroup>
                    <Input
                      placeholder="Enter "
                      value={formFields?.totalJobsCompleted}
                      onChange={(e) =>
                        _onFormFieldsChange(
                          "totalJobsCompleted",
                          e.target.value
                        )
                      }
                      onBlur={() => _onBlurFormFields("totalJobsCompleted")}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText style={{ fontSize: 14 }}>
                        Jobs
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                  {errors?.totalJobsCompleted ? (
                    <p className="validation-error">
                      {errors?.totalJobsCompleted}
                    </p>
                  ) : null}
                </>
              ) : null}
            </Col>
          </Row>

          <div className="chooseCredentials">
            <h1>Choose Credentials</h1>
            <div>
              {agentCredentialsConfig?.map((each) =>
                each?.value === "barLicense" ? (
                  userData?.user?.workType === "Attorney" ? (
                    <CustomInput
                      key={each?.value}
                      type="checkbox"
                      id={each?.value}
                      label={each?.label}
                      inline
                      checked={formFields?.credentials?.[each?.value] || false}
                      onChange={() =>
                        _onFormFieldsChange("credentials", each?.value)
                      }
                    />
                  ) : null
                ) : (
                  <CustomInput
                    key={each?.value}
                    type="checkbox"
                    id={each?.value}
                    label={each?.label}
                    inline
                    checked={formFields?.credentials?.[each?.value] || false}
                    onChange={() =>
                      _onFormFieldsChange("credentials", each?.value)
                    }
                  />
                )
              )}
            </div>
          </div>

          <Row key={seed}>
            <Col xl={6} sm={6} className="mb-4">
              <div className="uiDesign">
                <h1>
                  <CustomInput
                    key={seed}
                    type="radio"
                    id="demo1"
                    name="demoUIRadio"
                    checked={formFields?.currentUI === "demoUI1"}
                    onClick={() => _onFormFieldsChange("currentUI", "demoUI1")}
                  />
                  Default
                </h1>
                <Label for="demo1">
                  <img
                    src={
                      require("../../../../assets/img/OrderDashboard1.png")
                        .default
                    }
                    alt="background"
                  />
                </Label>
              </div>
            </Col>
            <Col xl={6} sm={6} className="mb-4">
              <div className="uiDesign">
                <h1>
                  <CustomInput
                    key={seed}
                    type="radio"
                    id="demo2"
                    name="demoUIRadio"
                    checked={formFields?.currentUI === "demoUI2"}
                    onClick={() => _onFormFieldsChange("currentUI", "demoUI2")}
                  />
                  Charcoal gray
                </h1>
                <Label for="demo2">
                  <img
                    src={
                      require("../../../../assets/img/OrderDashboard2.png")
                        .default
                    }
                    alt="background"
                  />
                </Label>
              </div>
            </Col>
            <Col xl={6} sm={6} className="mb-4">
              <div className="uiDesign">
                <h1>
                  <CustomInput
                    key={seed}
                    type="radio"
                    id="demo3"
                    name="demoUIRadio"
                    checked={formFields?.currentUI === "demoUI3"}
                    onClick={() => _onFormFieldsChange("currentUI", "demoUI3")}
                  />
                  Dark blue
                </h1>
                <Label for="demo3">
                  <img
                    src={
                      require("../../../../assets/img/OrderDashboard3.png")
                        .default
                    }
                    alt="background"
                  />
                </Label>
              </div>
            </Col>
            <Col xl={6} sm={6} className="mb-4">
              <div className="uiDesign">
                <h1>
                  <CustomInput
                    key={seed}
                    type="radio"
                    id="demo4"
                    name="demoUIRadio"
                    checked={formFields?.currentUI === "demoUI4"}
                    onClick={() => _onFormFieldsChange("currentUI", "demoUI4")}
                  />
                  Olive green
                </h1>
                <Label for="demo4">
                  <img
                    src={
                      require("../../../../assets/img/OrderDashboard4.png")
                        .default
                    }
                    alt="background"
                  />
                </Label>
              </div>
            </Col>

            <Col
              md={12}
              className="d-flex align-items-center justify-content-center"
            >
              <Button
                color="primary"
                siz="md"
                // className="mr-4"
                onClick={() => _toggleWhiteLabelUIColor(true)}
              >
                Customize
              </Button>
              {/* <Button color="primary" disabled={loading} onClick={_onSave}>
                {loading && <i className="fa fa-spinner fa-spin" />} Save
              </Button> */}
            </Col>
          </Row>
        </CardBody>
      </Card>

      <WhiteLabelUIColor
        key={seed}
        isAgentWebsiteProp={true}
        isOpen={whiteLabelUIColorModal.isOpen}
        toggle={() => _toggleWhiteLabelUIColor()}
        onSave={(colors) => _onSaveCustomizedUIColor(colors)}
        customizedUIData={customizedUI?.data}
      />

      <PersonalAddDescriptionModal
        isOpen={addServiceModal?.isOpen}
        data={addServiceModal?.data}
        toggle={_toggleAddServiceModal}
        serviceDetails={serviceDetails}
        setServiceDetails={setServiceDetails}
        setIsFormDirty={setIsFormDirty}
      />

      <PersonalWebsiteWarningModal
        isOpen={websiteWarningModal?.isOpen}
        data={websiteWarningModal?.data}
        toggle={_togglewebsiteWarningModal}
      />

      <ImageCropModal
        isOpen={imageCropModal?.isOpen}
        imgData={imageCropModal?.data}
        fieldName={imageCropModal?.fieldName}
        fileType={imageCropModal?.fileType}
        fileName={imageCropModal?.fileName}
        toggle={_toggleImageCropModal}
        onSuccess={(objFile, fieldName, fileType) =>
          _setCroppedImg(objFile, fieldName, fileType)
        }
      />
    </>
  );
};

export default forwardRef(PersonalWebsiteSetp1);
